import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { TagGi } from '../models/tag-gi';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { TagGiService } from '../services/tag-gi.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-tag-gi',
  templateUrl: './tag-gi.component.html',
  styleUrls: ['./tag-gi.component.scss']
})
export class TagGiComponent implements OnInit {

  // variáveis
  tagsFiltrados: TagGi[] = [];
  carregando = true;
  campoOrdenacao = 'tag';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  tipos: any[] = [{ id: 0, nome: 'Pedidos' }, { id: 1, nome: 'Integradores' }];
  tipoSelecionado = 0;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private tagService: TagGiService, private utilitarioService: UtilitarioService,
    private router: Router, private paginatorService: PaginatorService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.tipoSelecionado = this.router.getCurrentNavigation().extras.state.tipo;
    }
  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarTags();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarTags();
    this.paginator.firstPage();
  }

  buscarTags() {
    this.carregandoService.mostra('buscaTags');
    this.carregando = true;

    this.tagService.consultarTagComPaginacao(this.tipoSelecionado, this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
        this.tagsFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaTags');
      }, (erro) => {
        this.carregandoService.esconde('buscaTags');
        this.notificacaoService.erro(erro);
      });
  }

  novoTag() {
    this.router.navigate(['/configuracoes/tags/novo'], { state: { tipo: this.tipoSelecionado } });
  }

  editarTag(tag) {
    this.router.navigate(['/configuracoes/tags/editar', tag.id], { state: { tipo: this.tipoSelecionado } });
  }

  excluirTag(tag: TagGi) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Tag?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiTag');
        this.tagService.excluir(tag.id).subscribe(resp => {
          this.notificacaoService.sucesso('Tag excluída com sucesso!!!');
          this.carregandoService.esconde('excluiTag');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiTag');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarTags();
  }

  ngOnDestroy(): void {}
}